import { gql } from '@apollo/client'

const NOTE_REQUEST = gql`
  mutation evaluateRequest($comment: String, $note: Int, $id: UUID!) {
    updateRequest(
      input: {
        patch: { watcherComment: $comment, watcherNote: $note }
        id: $id
      }
    ) {
      clientMutationId
      request {
        id
        watcherServiceNote
        watcherServiceComment
      }
    }
  }
`

export default NOTE_REQUEST
